import React from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import dayjs from "dayjs";
import moment from "moment";
import { t } from "i18next";
import Apisetting from "./api/Apisetting";
import Apibank from "./api/Apibank";
import ApiNotify from "./api/notify/ApiNotify";
import Apiauth from "./api/Apiauth";
import Api from "./api/Api";
import apiAuthorization from "./services/api";
import AppContext from "./components/AppContext";
import ComponentApp from "./components/ComponentApp";
import { FilterClassNameIcon } from "./helpers/filterClassNameIcon";
import { showToast, getNextMinute, sendApiTelegram_call_api_error, calculateAverageTime, getRemovePrefix, openNotification, getRandomInt } from "./utils";
import { getBillingDateRange } from "./helpers/getBillingDateRange";
import { isTokenExpired, startTokenCheckInterval } from "./helpers/auth";
import { fetchData, handleCheckError } from "./utils/fetchData";
import { createMenuPathsMap, getLevelKeys } from "./helpers/createMenuPathsMap.helper";
import { publicPage, AuthRoutePage, authRoutes, RoutesPage } from "./route.page";
import { stopInactivityManager, startInactivityManager } from "./AppBehaviorManager";
import config from "./config/app.config";
import { message } from "antd";
import { debounce } from "lodash";
import { CONFIGMERCHENTID } from "./Data/configMerchant";

let tokenExpired = isTokenExpired?.();

class App extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      isMobile: window.innerWidth <= 768,
      currentRoute: window.location.pathname,
      isLoad: true,
      isLoadReportCustomers: false,
      maintanance: true,
      loadingBankAccounts: false,
      loadingRole: false,
      openDrawer: false,
      loadingClickUpdate: false,
      loadingClickUpdateInvoices: false,
      loadingClickUpdateMerchant: false,
      loadingReports: false,
      reloading: false,
      loadingCustomers: false,
      isCustomerLoading: false,
      isModalOpen: false,
      enabled_verify_hub: false,
      isSearching: false,
      notification: null,
      resProfileAdmin: null,
      selectedID: null,
      spinnerID: null,
      averageTime: null,
      averageUpdateTime: null,
      isMerchantData: null,
      nameMerchang: null,
      token: null,
      webHookUrl_wallet: config.webHookUrl_wallet,
      tokenMerchant: "",
      keyTab: "tab1",
      searchType: 'accountNumber',
      statusBank: "Active",
      typeBank: "all",
      randomInterval: '',
      balance: 0,
      counterAccount: 0,
      countCustomer: 0,
      countVerifyCustomer: 0,
      countAccountDelete: 0,
      countTransWithdraw: 0,
      countTransDeposit: 0,
      countTransApprove: 0,
      merchantId: 0,
      total_Due: 0,
      countVerifySlip: 0,
      summerysLoading: 0,
      withdrawUsage: [],
      dataTable: [],
      accPayoutActiveBank: [],
      customerData: [],
      resAllDataMerchang: [],
      permissionData: [],
      resDataRole: [],
      allBankAccountData: [],
      activeAccountData: [],
      resBankGroupData: [],
      resDataSetingNotify: [],
      resDataNotify: [],
      resReportCustomersSummary: null,
      isPermissionAdmin: [],
      roleObject: [],
      menuObject: [],
      menuPaths: {},
      levelKeys: {},
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {},
      },
      customerTableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
      },
      fetchDepositDataCallback: () => { },
      fetchWithdrawDataCallback: () => { },
      fetchAdminDataCallback: () => { },
      fetchRoleDataCallback: () => { },
      fetchVerifyslipDataCallback: () => { },
      fetchApproveDataCallback: () => { },
      fetchPendingTicketDataCallback: () => { },
      fetchAllTickerDataCallback: () => { },
      fetchVerifyMemberCallback: () => { },
      fetchProfileAdminCallback: () => { },
    };
    this.setFetchDepositDataCallback = this.setFetchDepositDataCallback.bind(this);
    this.handleReload = this.handleReload.bind(this);
    this.setReloading = this.setReloading.bind(this);
    this.setFetchWithdrawDataCallback = this.setFetchWithdrawDataCallback.bind(this);
    this.setFetchApproveDataCallback = this.setFetchApproveDataCallback.bind(this);
    this.onLocleChang = this.onLocleChang.bind(this);
    this.onChangeTab = this.onChangeTab.bind(this);
    this.get_balance_summerys = this.get_balance_summerys.bind(this);
    this.setLoadingCustomer = this.setLoadingCustomer.bind(this);
    this.fetchDataSetingNotify = this.fetchDataSetingNotify.bind(this);
    this.fetchDataNotify = this.fetchDataNotify.bind(this);
    this.getAllDataCustomer = this.getAllDataCustomer.bind(this);
    this.fetchDataInvoice = this.fetchDataInvoice.bind(this);
    this.getAllDataMerchang = this.getAllDataMerchang.bind(this);
    this.getDataBankGropu = this.getDataBankGropu.bind(this);
    this.fetchPermissions = this.fetchPermissions.bind(this);
    this.setLoadingInvoices = this.setLoadingInvoices.bind(this);
    this.setLoadingAccounts = this.setLoadingAccounts.bind(this);
    this.setFetchAdminDataCallback = this.setFetchAdminDataCallback.bind(this);
    this.setFetchRoleDataCallback = this.setFetchRoleDataCallback.bind(this);
    this.setFetchVerifyslipDataCallback = this.setFetchVerifyslipDataCallback.bind(this);
    this.pageName = this.pageName.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.isIcon = this.isIcon.bind(this);
    this.setSpinnerId = this.setSpinnerId.bind(this);
    this.setCountTransPayOut = this.setCountTransPayOut.bind(this);
    this.setCountTransPayIn = this.setCountTransPayIn.bind(this);
    this.setCountTransApproval = this.setCountTransApproval.bind(this);
    this.fetchPromiseData = this.fetchPromiseData.bind(this);
    this.fetchDataReportCustomersSummary = this.fetchDataReportCustomersSummary.bind(this);
    this.fetchPromiseCountData = this.fetchPromiseCountData.bind(this);
    this.setFetchPendingTicketDataCallback = this.setFetchPendingTicketDataCallback.bind(this);
    this.setFetchAllTickerDataCallback = this.setFetchAllTickerDataCallback.bind(this);
    this.setFetchVerifyMemberCallback = this.setFetchVerifyMemberCallback.bind(this);
    this.setFetchProfileAdminCallback = this.setFetchProfileAdminCallback.bind(this);
    this.setCountVerifySlip = this.setCountVerifySlip.bind(this);
    this.setCountVerifyCustomer = this.setCountVerifyCustomer.bind(this);
    this.setAverageTime = this.setAverageTime.bind(this);
    this.setDataMerchant = this.setDataMerchant.bind(this);
    this.setDataRole = this.setDataRole.bind(this);
    this.setLoadingRole = this.setLoadingRole.bind(this);
    this.setLoadingMenu = this.setLoadingMenu.bind(this);
    this.getActiveBankAccounts = this.getActiveBankAccounts.bind(this);
    this.getDataBankAccount = this.getDataBankAccount.bind(this);
    this.handleChangStatus = this.handleChangStatus.bind(this);
    this.handleChangType = this.handleChangType.bind(this);
    this.setChangStatus = this.setChangStatus.bind(this);
    this.setChangType = this.setChangType.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.onTypeChange = this.onTypeChange.bind(this);
    this.setSearching = this.setSearching.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeEnabled = this.onChangeEnabled.bind(this);
    this.onRandomInt = this.onRandomInt.bind(this);
    this.debouncedFetcDataAccount = debounce(this.getDataBankAccount, 300);
  }

  componentDidMount() {
    const pathname = this.props.location.pathname;
    const cleanedLocale = (pathname === "/" ? "/login" : pathname).substring(1);
    this.onLocleChang(cleanedLocale);
    if (cleanedLocale === "login") {
      this.setLoading(false);
    } else {
      startTokenCheckInterval();
      startInactivityManager();
      this.setLoadingInvoices(true);
      window.addEventListener("resize", this.handleResize);
    }
  }
  componentWillUnmount() {
    stopInactivityManager();
    window.removeEventListener("resize", this.handleResize);
  }
  handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
  onRandomInt = async () => {
    const randomInt = getRandomInt(8);
    this.setState({ randomInterval: randomInt });
  };

  // ------------- Functions  call API ------------------
  firsrTimeFetchData = async () => {
    const { customerTableParams } = this.state;
    this.setLoading(true);
    this.setLoadingCustomer(true);
    this.setState({ loadingMenu: true, loadingRole: true });
    try {
      await Promise.all([
        this.fetchPromiseData(),
        this.fetchPromiseCountData(),
        this.fetchPermissions(),
        this.getActiveBankAccounts(),
        this.getAllDataCustomer(customerTableParams),
        this.getDataBankAccount(),
        this.getAllDataMerchang(),
        this.getDataBankGropu(),
        this.fetchDataSetingNotify(),
        this.fetchDataNotify(),
        this.fetchDataReportCustomersSummary(),
        this.onRandomInt()
      ]);
    } catch (error) {
      console.error("Error loading initial data:", error);
      this.setLoading(false);
    }
  };
  // รวมการ fetch API getRole_permissions, getProfileAdmin, getRole_menu  ไว้ในเมธอดเดียว
  fetchPromiseData = async () => {
    let { selectedID } = this.state;
    let active = localStorage.getItem("selectedID");
    let active_merchantId = parseInt(selectedID || active);
    try {
      const [resPermissions, resMenu, resProfileAdmin] = await Promise.all([Api.getRole_permissions({ merchantId: active_merchantId, }), Api.getRole_menu(), Apiauth.getProfileAdmin(),]);

      if (!resPermissions.data.success) message.error(resPermissions?.data?.message || "Failed to fetch permissions");
      if (!resMenu.data.success) message.error(resMenu?.data?.message || "Failed to fetch menu");
      if (!resProfileAdmin.data.success) message.error(resProfileAdmin?.data?.message || "Failed to fetch profile");

      const menuData = resMenu.data.data || [];
      const permissionsData = resPermissions.data.data || [];
      const resProfile = resProfileAdmin?.data?.user || [];
      const menuPaths = createMenuPathsMap(menuData);
      const levelKeys = getLevelKeys(menuData);
      // หา Permission ของ Role ปัจจุบัน
      let currentPermissionsAdmin = permissionsData.find((o) => o.id === resProfile?.roleID,);
      // current Permissions Admin
      let isPermissionAdmin = Array.isArray(currentPermissionsAdmin?.permission) ? currentPermissionsAdmin.permission : [];
      let PermissionAdmin = isPermissionAdmin.filter((item) => item.ispublic === true && item.isPublic === 1,);
      this.setState({
        roleObject: permissionsData,
        menuObject: menuData,
        menuPaths: menuPaths,
        levelKeys: levelKeys,
        isPermissionAdmin: PermissionAdmin,
        resDataRole: permissionsData,
        resProfileAdmin: { ...resProfile, permissions: PermissionAdmin },
        loadingMenu: false,
        loadingRole: false,
        reloading: false,
      });
    } catch (error) {
      console.log("Error fetching data:", error.response?.data?.message || error?.message,);
      this.setState({ loadingMenu: false, loadingRole: false })
      sendApiTelegram_call_api_error(error, "fetchPromiseData");
    }
  };
  // รวมการ fetch API get_data_deposit, gtdata_withdraws, get_data_deposit ONHOLD, getVerifyslipTransactions, getDataVerifyCustomer ไว้ในเมธอดเดียว
  fetchPromiseCountData = async () => {
    let payload = {
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      offset: 1,
      limit: 10,
    };
    try {
      const [resWTH, resDep, resOnHole, resVslip, resVcustomer] = await Promise.all([
        Apibank.gtdata_withdraws({ ...payload, type: "withdraw", }),
        Apibank.get_data_deposit(payload),
        Apibank.get_data_deposit({ ...payload, status: "ONHOLD", }),
        Apibank.getVerifyslipTransactions(payload),
        Apiauth.getDataVerifyCustomer(payload)]);

      let rowsWTH = Array.isArray(resWTH?.data?.data?.rows) ? resWTH?.data?.data?.rows : [];
      let averageTime = calculateAverageTime(rowsWTH);

      if (resWTH?.status === 200) { // Withdraw
        this.setState({
          averageTime: averageTime,
          averageUpdateTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          countTransWithdraw: resWTH?.data?.data?.count,
        })
      };

      if (resDep?.status === 200) this.setState({ countTransDeposit: resDep?.data?.data_transactions?.data?.count, }); // Deposit
      if (resOnHole?.status === 200) this.setState({ countTransApprove: resOnHole?.data?.data_transactions?.data?.count, }); // ONHOLD
      if (resVslip?.status === 200) this.setState({ countVerifySlip: resVslip?.data?.count, }); // VerifySlip
      if (resVcustomer?.status === 200) this.setState({ countVerifyCustomer: resVcustomer?.data?.count, }); // VerifyCustomer

    } catch (error) {
      console.error("Error fetching count data:", error);
    } finally {
      this.setState({ isLoad: false, });
    }
  }
  getAllDataCustomer = async (params = {}) => {
    const { pagination, filters = {} } = params;
    let { selectedID } = this.state;
    let active = localStorage.getItem("selectedID");
    let active_merchantId = parseInt(selectedID || active);
    let { search, typeSearch } = filters;
    let response;
    let apiUrlGet = `/api/v1/admin/get_customer`;
    let apiUrlPOST = `/api/v1/admin/chack_uuid`;
    let bodyData = null;
    if (typeSearch && search) {
      bodyData = JSON.stringify({
        ...filters,
        merchantId: active_merchantId,
      });
      response = await apiAuthorization.post(`${apiUrlPOST}`, bodyData);
    } else {
      // --- กรณีดึงข้อมูลปกติ (ใช้ GET) ---
      const queryParams = {};
      if (pagination?.current && pagination?.pageSize) {
        queryParams.page = pagination.current;
        queryParams.limit = pagination.pageSize;
      }
      response = await apiAuthorization.get(`${apiUrlGet}`, { params: queryParams, });
    }
    try {
      const data = response.data;
      if (data.success) {
        const fetchedData = Array.isArray(data.data) ? data.data : [];
        const totalItems = data.totalItems || fetchedData.length;
        this.setState((prevState) => ({
          customerData: fetchedData,
          isCustomerLoading: false,
          reloading: false,
          countCustomer: totalItems,
          customerTableParams: {
            ...params,
            pagination: {
              ...params?.pagination,
              total: totalItems,
            },
          },
        }));
      } else {
        this.setState({ customerTableParams: { ...params, pagination: { total: 0 } }, customerData: [], isCustomerLoading: false, });
      }
    } catch (error) {
      sendApiTelegram_call_api_error(error, "fetchDataInvoice");
      console.error("Error fetching customer data:", error);
      handleCheckError(error, "getAllDataCustomer", this.getLoading);
      this.setState({ customerTableParams: { ...params, pagination: { total: 0 } }, customerData: [], isCustomerLoading: false, });
    }
  };
  getDataBankGropu = async () => {
    fetchData(
      () => Api.getall_BankGrop(),
      (res) => {
        let arrData = Array.isArray(res.data);
        this.setState(() => ({ resBankGroupData: arrData ? res.data : [], isLoad: false, }));
      },
      () => this.setLoading(false),
    ).finally((error) => {
      if (error) return console.log(error);
    });
  };
  getAllDataMerchang = async () => {
    let { selectedID } = this.state;
    let active = localStorage.getItem("selectedID");
    let active_merchantId = parseInt(selectedID || active);
    fetchData(
      () => Apiauth.getalldata_memerchang(),
      (res) => {
        let dataArray = Array.isArray(res?.data) ? res?.data : [];
        let isMerchant = dataArray?.find((o) => o.id === active_merchantId);
        this.setState(
          () => ({
            resAllDataMerchang: dataArray,
            reloading: false,
            merchantId: active_merchantId,
            loadingCustomers: false,
          }),
          () => this.setDataMerchant(isMerchant),
        );
      },
      () => this.setLoading(false),
    ).catch((error) => {
      console.log(error);
      sendApiTelegram_call_api_error(error, "getAllDataMerchang");
      handleCheckError(error, "getAllDataMerchang", this.getLoading);
    });
  };
  getDataBankAccount = async () => {
    const { statusBank, typeBank, tableParams } = this.state;
    let { pageSize, current } = tableParams.pagination;
    const { search, typeSearch } = tableParams?.filters || {};
    this.setState({ loadingBankAccounts: true }); // เปิด loading ก่อนเริ่ม

    let payload = {
      limit: pageSize,
      page: current,
      accountType: typeBank, //all | "deposit" | "withdrawal" | "verifying_account"
      bankStatus: statusBank, //all | "Active" | "Inactive" | "Delete",
    }
    let payloadSearch = {
      typeSearch: typeSearch,
      search: search,
    }
    if (search) {
      this.setState({ isSearching: true })
    } else {
      this.setState({ isSearching: false })
    }

    try {
      const res = await Apisetting.getDataBankAccounts(search ? payloadSearch : payload);
      if (res.status === 200) {
        this.setState(
          (prevState) => ({
            counterAccount: res.data.count,
            loadingBankAccounts: false,
            allBankAccountData: res.data.data,
            tableParams: {
              ...prevState.tableParams,
              pagination: {
                ...prevState.pagination,
                current: res?.data?.page || tableParams.pagination.current,
                pageSize: res?.data?.limit || tableParams.pagination.current,
                total: res.data.count,
              },
            },
          })
        );
      }
    } catch (error) {
      console.log(error)
      this.setState({ loadingBankAccounts: false, })
    } finally {
      this.setState({ reloading: false, isLoad: false, loadingBankAccounts: false, });
    }
  }
  getActiveBankAccounts = async () => {
    try {
      Apisetting.getActiveBankAccount()
        .then((res) => {
          if (res.status === 200) {
            const activeBank = res?.data?.data[0]?.bankAccounts || [];
            const withdrawAcc = activeBank?.filter((o) => o?.accountType === "withdrawal" && o?.status_bank === "Active");
            let balance = withdrawAcc?.length > 0 ? withdrawAcc?.find((o) => o?.balance) : 0;
            if (balance?.id) sessionStorage.setItem("id", balance?.id);
            this.setState({
              activeAccountData: activeBank,
              accPayoutActiveBank: withdrawAcc,
              balance: balance?.balance || 0,
              loadingBankAccounts: false,
              reloading: false,
              isLoad: false,
            })
          }
        }).catch((err) => {
          console.log(err)
          this.setState({ activeAccountData: [], loadingBankAccounts: false, reloading: false, isLoad: false, });
        });

    } catch (error) {
      this.setState({ activeAccountData: [], loadingBankAccounts: false, reloading: false, isLoad: false, });
      console.log(error)

    }
  }
  fetchPermissions = async () => {
    try {
      const data = await Apiauth.getDataPermissions();
      if (data.data.success) this.setState({ permissionData: data?.data?.data, isLoad: false, });
    } catch (error) {
      console.error("Failed to fetch permissions:", error);
      handleCheckError(error, "fetchPermissions", this.getLoading);
      sendApiTelegram_call_api_error(error, "fetchPermissions");
      this.setState({ isLoad: false, });
    }
  };
  fetchDataSetingNotify = async () => {
    this.setState({ isLoad: true });
    try {
      const res = await ApiNotify.getDataSetingNotify();
      let array = Array.isArray(res?.data?.data) ? res?.data?.data : [];
      if (res?.data?.success) this.setState({ resDataSetingNotify: array, isLoad: false, }, () => this.setReloading(false));
    } catch (error) {
      handleCheckError(error, "fetchDataSetingNotify", this.getLoading);
      sendApiTelegram_call_api_error(error, "fetchDataSetingNotify");
      this.setReloading(false)
      console.error("Failed to fetch :", error);
      this.setState({ isLoad: false });
    }
  };
  fetchDataNotify = async () => {
    this.setState({ isLoad: true });
    try {
      const res = await ApiNotify.getDataNotify();
      let array = Array.isArray(res?.data?.data) ? res?.data?.data : [];
      if (res?.data?.success) this.setState({ resDataNotify: array, isLoad: false, });
    } catch (error) {
      handleCheckError(error, "fetchDataNotify", this.getLoading);
      sendApiTelegram_call_api_error(error, "fetchDataNotify");
      console.error("Failed to fetch :", error);
      this.setState({ isLoad: false });
    }
  };
  fetchDataReportCustomersSummary = async (params = null) => {
    let postData = {
      "merchantId": params, // id or null
      "merchantNotIns": CONFIGMERCHENTID, // ยกเว้น merchantId ที่ไม่ต้องการ
    }
    this.setState({ isLoadReportCustomers: true });
    try {
      const res = await Api.getReportCustomersSummary(postData);
      let object = res?.data?.data || {};
      if (res?.data?.success) this.setState({ resReportCustomersSummary: object, isLoadReportCustomers: false, });
    } catch (error) {
      this.setState({ isLoadReportCustomers: false });
      console.error("Failed to fetch :", error);
    }
  };
  fetchDataInvoice = async () => {
    const date = getBillingDateRange();
    let postData = { startDate: date?.objectDate?.startDate, type: "today", };
    try {
      Api.getInvoice(postData)
        .then((res) => {
          if (res.data.success) {
            let originalData = res?.data;
            const total_Due = originalData?.Total_Due;
            this.setState({ total_Due: total_Due, loadingClickUpdateInvoices: false, });
          } else {
            this.setState({ loadingClickUpdateInvoices: false });
          }
        })
        .catch((error) => {
          handleCheckError(error, "fetchDataInvoice", this.getLoading);
          sendApiTelegram_call_api_error(error, "fetchDataInvoice");
          console.log(error);
          this.setState({ loadingClickUpdateInvoices: false });
        });
    } catch (error) {
      handleCheckError(error, "fetchDataInvoice", this.getLoading);
      sendApiTelegram_call_api_error(error, "fetchDataInvoice");
      console.log(error);
      this.setState({ loadingClickUpdateInvoices: false });
    }
  };
  get_balance_summerys = async (id) => {
    if (!id) return showToast("error", "ไม่พบ ID");
    const { summerysLoading } = this.state;
    let ext = 120000;
    let disabledOnTime = await getNextMinute(ext);
    if (summerysLoading === id) return alert(disabledOnTime);
    this.setLoadingAccounts(false);
    this.setSpinnerId(id);
    this.setState({ loadingBankAccounts: true, summerysLoading: id });
    Apibank.get_balance_summery({ id: id })
      .then((res) => {
        if (res.data.success) {
          this.setState({ loadingBankAccounts: false, withdrawUsage: res?.data?.withdrawUsage || [] });
          sessionStorage.setItem("ext", `${new Date()}`);
          showToast("success", res.data.message);
          this.setLoadingAccounts(false);
          this.setSpinnerId(0);
          if (window.location.pathname === "/dashboard") this.getActiveBankAccounts();
          setTimeout(() => {
            this.setState({ summerysLoading: 0 });
            sessionStorage.removeItem("ext");
          }, ext);
        }
      })
      .catch((error) => {
        console.log("error", error);
        sessionStorage.setItem("ext", `${new Date()}`);
        setTimeout(() => {
          this.setState({ summerysLoading: 0 });
          sessionStorage.removeItem("ext");
        }, ext);
        this.setState({ loadingBankAccounts: false, summerysLoading: 0 });
        this.setLoadingAccounts(false);
        this.setSpinnerId(0);
        handleCheckError(error, "get_balance_summerys", this.getLoading);
      });
  };
  onChangeEnabled = async (value) => {
    const { getAllDataMerchang } = this
    Apisetting.enabled_verify_hub({ enabled_verify_hub: value })
      .then((res) => {
        if (res.status === 200) {
          showToast("success", t("{{action}} customer verification service", { action: value ? t("enable") : t("disable") }));
          if (typeof getAllDataMerchang === "function") getAllDataMerchang();
        }
      })
      .catch((error) => {
        openNotification("error", `Error`, error.response?.data?.message || error.message);
      })
      .finally(() => { });
  };
  // ---------------------------END CALL API------------------------------

  // ----------------- Set State ต่างๆ ----------------
  setSpinnerId = (id) => this.setState({ spinnerID: id });
  setReloading = (_isLoad) => this.setState({ reloading: _isLoad });
  setShowDrawer = (_isLoad) => this.setState({ openDrawer: _isLoad });
  setSearching = (_isLoad) => this.setState({ isSearching: _isLoad });
  setChangStatus = (status) => {
    this.setState((prevState) => ({
      loadingBankAccounts: true,
      tableParams: {
        ...prevState.tableParams,
        pagination: {
          ...prevState.tableParams.pagination,
          current: 1
        },
      },
    }));
    this.setState({ statusBank: status }, () => this.debouncedFetcDataAccount());
  };
  setChangType = (type) => {
    this.setState((prevState) => ({
      loadingBankAccounts: true,
      tableParams: {
        ...prevState.tableParams,
        pagination: {
          ...prevState.tableParams.pagination,
          current: 1
        },
      },
    }));
    this.setState({ typeBank: type }, () => this.debouncedFetcDataAccount())
  };
  setLoadingInvoices = (_isLoad) => this.setState({ loadingClickUpdateInvoices: _isLoad });
  setLoadingAccounts = (_isLoad) => this.setState({ loadingBankAccounts: _isLoad });
  setLoading = async (_loading) => this.setState({ isLoad: _loading, loadingClickUpdate: _loading, });
  setLoadingRole = async (_loading) => this.setState({ loadingRole: _loading, });
  setDataRole = async (data) => this.setState({ resDataRole: data, });
  setLoadingMenu = async () => this.setState({ loadingMenu: true, });
  setAverageTime = async (ms, updateTime) => this.setState({ averageTime: ms, averageUpdateTime: updateTime, });
  setCountTransPayIn = (callback) => this.setState({ countTransDeposit: callback });
  setCountTransPayOut = (callback) => this.setState({ countTransWithdraw: callback });
  setCountTransApproval = (callback) => this.setState({ countTransApprove: callback });
  setCountVerifySlip = (callback) => this.setState({ countVerifySlip: callback });
  setCountVerifyCustomer = (callback) => this.setState({ countVerifyCustomer: callback });
  setLoadingCustomer = (_e) => this.setState({ isCustomerLoading: _e, });
  setNotification = (msg) => this.setState({ notification: msg });
  setMerchantId = (id) => this.setState({ merchantId: parseInt(id), });
  getLoading = (_loading) => { this.setLoading(_loading); this.setLoadingCustomer(_loading); };
  setDataMerchant = (data) => this.setState({ isMerchantData: data, tokenMerchant: data?.token_auth, nameMerchang: data?.name, enabled_verify_hub: data?.enabled_verify_hub, });

  // Set Callback Function สำหรับการรีเฟรชข้อมูลในแต่ละหน้าที่เกี่ยวข้อง
  // ฟังก์ชันนี้จะถูกเรียกจาก (deposit)
  setFetchDepositDataCallback = (callback) => this.setState({ fetchDepositDataCallback: callback, reloading: false, });
  // ฟังก์ชันนี้จะถูกเรียกจาก (Approve)
  setFetchApproveDataCallback = (callback) => this.setState({ fetchApproveDataCallback: callback, reloading: false, });
  // ฟังก์ชันนี้จะถูกเรียกจาก (Withdraw)
  setFetchWithdrawDataCallback = (callback) => this.setState({ fetchWithdrawDataCallback: callback, reloading: false, });
  // ฟังก์ชันนี้จะถูกเรียกจาก (User)
  setFetchAdminDataCallback = (callback) => this.setState({ fetchAdminDataCallback: callback, reloading: false, });
  // ฟังก์ชันนี้จะถูกเรียกจาก (Role)
  setFetchRoleDataCallback = (callback) => this.setState({ fetchRoleDataCallback: callback, loadingRole: true, });
  // ฟังก์ชันนี้จะถูกเรียกจาก (Verifyslip)
  setFetchVerifyslipDataCallback = (callback) => this.setState({ fetchVerifyslipDataCallback: callback, reloading: false, });
  // ฟังก์ชันนี้จะถูกเรียกจาก (All-Ticker)
  setFetchAllTickerDataCallback = (callback) => this.setState({ fetchAllTickerDataCallback: callback, reloading: false, });
  // ฟังก์ชันนี้จะถูกเรียกจาก (Pending-Ticket)
  setFetchPendingTicketDataCallback = (callback) => this.setState({ fetchPendingTicketDataCallback: callback, reloading: false, });
  // ฟังก์ชันนี้จะถูกเรียกจาก (VerifyMember)
  setFetchVerifyMemberCallback = (callback) => this.setState({ fetchVerifyMemberCallback: callback, reloading: false, });
  // ฟังก์ชันนี้จะถูกเรียกจาก (ProfileAdmin)
  setFetchProfileAdminCallback = (callback) => this.setState({ fetchProfileAdminCallback: callback, reloading: false, });
  // ---------------------------End Set State------------------------------

  // ---------------------------handler ต่างๆ------------------------------
  handleLogin = (payload) => {
    let { userToken, userData, selectedID } = payload || {};
    this.setState({ token: userToken, resProfileAdmin: userData, selectedID: parseInt(selectedID), merchantId: parseInt(selectedID), });
  };
  handleChang = (is) => this.setShowDrawer(is);
  handleChangStatus = (is) => this.setChangStatus(is);
  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      (prevState) => ({
        loadingBankAccounts: true,
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            ...prevState.tableParams.pagination,
            current: pagination.current,
            pageSize: pagination.pageSize,
          },
          filters,
          sortField: sorter.field,
          sortOrder: sorter.order,
        },
      }),
      () => this.debouncedFetcDataAccount()
    );
  };
  onTypeChange = (value) => {
    const { tableParams } = this.state;
    const search = tableParams?.filters?.search;
    this.setState({ searchType: value }, () => {
      if (search) {
        this.setState((prevState) => ({
          tableParams: {
            ...prevState.tableParams,
            pagination: { ...prevState.tableParams.pagination, current: 1 },
            filters: { ...prevState.tableParams.filters, typeSearch: value },
          },
        }), this.debouncedFetcDataAccount);
      }
    });
  };
  onSearch(value) {
    if (!value) {
      this.setState((prevState) => ({
        tableParams: {
          ...prevState.tableParams,
          pagination: { ...prevState.tableParams.pagination, current: 1 },
          filters: {},
        },
      }));
      return this.debouncedFetcDataAccount()
    };

    this.setState((prevState) => ({
      tableParams: {
        ...prevState.tableParams,
        pagination: { ...prevState.tableParams.pagination, current: 1 },
        filters: {
          ...prevState.tableParams.filters,
          search: value,
          typeSearch: this.state.searchType
        },
      },
    }), this.debouncedFetcDataAccount);
  }
  handleChangType = (is) => this.setChangType(is);
  handleCancel = () => this.setState({ isModalOpen: false });
  handleOk = () => this.setState({ isModalOpen: true });

  onLocleChang = async (path) => {
    let locale = window.location.pathname;
    let cleanedLocale = locale.substring(1);
    this.pageName(path || cleanedLocale);
    if (!tokenExpired) {
      window.scrollTo(0, 0);
      this.setState({ statusBank: "Active", });
      this.isIcon();
      this.setState({ currentRoute: path?.path, }); // ใช้ pathname จาก react-router-dom
      this.setLoadingCustomer(true);
      this.setState({ loadingCustomers: true, });
      this.setState((prevState) => ({
        customerTableParams: {
          ...prevState.customerTableParams,
          pagination: {
            ...prevState.customerTableParams.pagination,
            current: 1,
          },
        },
      }));
    }
  };

  pageName(params) {
    let locale = params?.labelKey || params;
    let webname = config.web_name;
    let titleElement = document.getElementById("title");
    this.setState({ keyTab: "tab1" });
    if (titleElement) titleElement.textContent = `${webname}  ${locale ? `- ${getRemovePrefix(t(locale))}` : ""}`;
  }
  onChangeTab = (key) => { this.setState({ keyTab: key, loadingBankAccounts: true, allBankAccountData: [] }, () => this.getDataBankAccount(),) };
  isIcon() { let locale = window.location.pathname; let icon = FilterClassNameIcon(locale); return icon || null; }

  // Reload ข้อมูลหลายๆฟังชั่นในเมธอดเดียวกัน ตาม key ที่ส่งมา
  handleReload = async (key) => {
    const actionMap = { // Object Mapping
      "dashboard": () => { this.setState({ loadingBankAccounts: true, }); return this.getActiveBankAccounts?.(); },
      "bank-bank-customer": () => { this.setLoadingCustomer?.(true); return this.getAllDataCustomer?.(); },
      "bank-account": () => { return this.getDataBankAccount?.(); },
      "manage-merchant": () => { return this.getAllDataMerchang?.(); },
      "chart-report": () => { return this.fetchDataReportCustomersSummary?.(); },
      "deposit-transaction": this.state.fetchDepositDataCallback,
      "withdraw-transaction": this.state.fetchWithdrawDataCallback,
      "user": this.state.fetchAdminDataCallback,
      "role": this.state.fetchRoleDataCallback,
      "setting": this.fetchDataSetingNotify,
      "profile": this.fetchPromiseData,
      "verifyslip-transactions": this.state.fetchVerifyslipDataCallback,
      "top-up-approval": this.state.fetchApproveDataCallback,
      "all-ticket": this.state.fetchAllTickerDataCallback,
      "pending-ticket": this.state.fetchPendingTicketDataCallback,
      "verify-customer": this.state.fetchVerifyMemberCallback,
    };
    try {
      const action = actionMap[key];
      if (typeof action === "function") {
        this.setState({ reloading: true })
        await action();//เรียกใช้งานฟังก์ชัน
      } else { message.warning(`Auto-update failed: Invalid key: ${key}`, 6) }
    } catch (error) { console.log("Auto-update failed:", error); } finally { this.setState({ reloading: false }) }
  };
  // ---------------------------End handler------------------------------

  render() {
    const { ...state } = this.state;
    const { menuPaths } = this.state;
    const { location } = this.props;
    let path = location.pathname;
    const baseUrl = process.env.PUBLIC_URL;

    if (baseUrl && path.startsWith(baseUrl)) path = path.substring(baseUrl.length);
    if (path.startsWith("/")) path = path.substring(1);
    const activeKey1 = path || "/";
    const activeKey = path.startsWith("/") ? path.substring(1) : path;

    const contextValue = {
      ...state,
      ...this, // กระจาย methods ทั้งหมดจาก instance (ถ้าชื่อตรงกันอยู่แล้ว)
      t: t, activeKey1: activeKey, handleCheckError: handleCheckError,
    };
    const isAuthRoute = authRoutes.includes(activeKey1);
    const _URL = process.env.PUBLIC_URL;
    const privatePaths = Object.values(menuPaths); // ดึง path ทั้งหมดจาก menuPaths
    const isRoutes = RoutesPage.filter(route => privatePaths.includes(route.path) || publicPage.includes(route.path)); // อนุญาตให้เข้าถึงเส้นทางที่อยู่ใน menuPaths หรือ allAllowedPage

    return (<AppContext.Provider value={contextValue}>
      <div id="wrapper">
        {isAuthRoute ? (<Switch>{AuthRoutePage.map((route, index) => (<Route key={index} exact path={`${_URL}${route.path}`} component={route.component} />))}</Switch>)
          : (<><ComponentApp handleOk={this.handleOk} handleChang={this.handleChang} handleReload={this.handleReload} handleCancel={this.handleCancel} history={this.props.history} />
            {/* main */}
            <div id="main-content"><Switch>{isRoutes.map((route, index) => (<Route key={index} exact path={`${_URL}${route.path}`} component={route.component} />))}</Switch></div>
          </>)}
      </div>
    </AppContext.Provider>);
  }
}
export default withRouter(connect(null, {})(App));
// *******************************************************//


